/**
 * Minimal frontend audit logger.
 * Logs structured events with an event type, optional metadata, and a trace ID
 * that can be sent to the backend for correlation.
 */
import { generateTraceId } from './trace';

function maskEmail(email?: string): string | undefined {
  if (!email) return undefined;
  const [local, domain] = email.split('@');
  if (!domain) return '***';
  const maskedLocal = local.length <= 2 ? '***' : `${local[0]}***${local.slice(-1)}`;
  return `${maskedLocal}@${domain}`;
}

export function logAudit(event: string, metadata: Record<string, unknown> = {}, traceId?: string): string {
  const id = traceId || generateTraceId();
  const sanitizedMetadata = { ...metadata };

  if (sanitizedMetadata.email && typeof sanitizedMetadata.email === 'string') {
    sanitizedMetadata.email = maskEmail(sanitizedMetadata.email as string);
  }

  const payload = {
    level: 'audit',
    event,
    traceId: id,
    metadata: sanitizedMetadata,
    timestamp: new Date().toISOString(),
  };

  // Console info is sufficient for audit visibility in client logs
  // while keeping implementation lightweight.
   
  console.info('audit', payload);

  return id;
}
